import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { getCMSbyIndex, getAhlinCMSbyId } from '../../reduxStore/HeadlessCMS/headlessCmsActions';
import { ArticleArea } from '../../Styling/Layout/ContentArea';
import LocaleContext from '../../state/contexts/LocaleContext'
import { messages } from './HeadlessCmsContainer.i18n'
import { useParams } from 'react-router-dom';

const HeadlessCmsContainer = (props) => {

    const showToasts = true
    const { id } = useParams();
    const locale = React.useContext(LocaleContext);
    const localeMessages = messages[locale]

    const state = useSelector(state => state.headlessCMS)
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (!state.data[id]) {
            if (id === 'avslutningskode' || id === 'webservice_api' || id === 'bislab_prisliste' || 'mva') {
            dispatch(getAhlinCMSbyId(id, showToasts, localeMessages))
        } else {
            dispatch(getCMSbyIndex(id, showToasts, localeMessages))
        }
        }
    }, [id, dispatch, showToasts, localeMessages])

    useEffect(() => {
        setIsLoading(state.loading)
    }, [state.loading])

    const getCMSContent = (htmlContent) => {
        const validIds = ['prislister', 'avslutningskode', 'webservice_api', 'bislab_prisliste', 'mva'];
        
        if (Array.isArray(htmlContent) && htmlContent.length > 0 && validIds.includes(id)) {
            return (
                <div>
                    {htmlContent.map((item) => (
                        <div key={item.id}>
                            <h2 dangerouslySetInnerHTML={{ __html: item.title.rendered }}></h2>
                            <div dangerouslySetInnerHTML={{ __html: item.content.rendered }}></div>
                        </div>
                    ))}
                </div>
            );
        } else if (state.data[id]) {
            return (
                <div dangerouslySetInnerHTML={{ __html: state.data[id] }}></div>
            )
        } else if (isLoading) {
            return (
                <div style={{ color: '#666', fontFamily: "Fellix, sans-serif", fontSize: '16px', padding: '20px' }}>
                    Laster info...
                </div>
            )
        } else {
        return (
            <div style={{ color: 'red', textAlign: 'center', fontWeight: '600', fontFamily: "Fellix, sans-serif", fontSize: '20px' }}>
              Noe gikk galt ved henting av informasjon, du kan fortsatt bruke Kunderportalen som vanlig.
            </div>
        )}
    }
      

        return (
            <ArticleArea>
                {getCMSContent(state.data[id] || [])}
            </ArticleArea>
        
        )

}

export default HeadlessCmsContainer